export const deleteParentPlacements = () => {
  return {
    type: 'PARENT_DELETE_PLACEMENTS',
  };
};
